import * as React from 'react';
import { ELumaBotFlowType, useAvailabilitiesCount } from 'ui-model';
import { useSettingSchedulerDates } from 'hooks';
import { useLumaBotContext } from '../../LumaBot.context';

const useCheckForAvailabilities = (filters: Record<string, unknown>) => {
  const [shouldHideScheduler, setHideScheduler] = React.useState(false);
  const { pushFlowTemplate } = useLumaBotContext();
  const { startDate, endDate } = useSettingSchedulerDates();

  const { isLoading } = useAvailabilitiesCount(
    {
      status: 'available',
      dateMin: startDate ? startDate.format() : '',
      dateMax: endDate ? endDate.format() : '',
      ...filters,
    },
    {
      refetchOnWindowFocus: false,
      retry: false,
      onSuccess: (data: number[]) => {
        if (data.length === 1 && data[0] === 0) {
          setHideScheduler(true);
          pushFlowTemplate(ELumaBotFlowType.NoAvailabilities);
        }
      },
    },
  );

  return {
    isLoading,
    shouldHideScheduler,
  };
};

export default useCheckForAvailabilities;
